'use client'

import { useEffect, useState } from 'react'

import type { Topic } from '@/payload-types'

// --- Client-side fetch topics ---

// In getTopics.ts
export const useTopics = (collection?: string) => {
  const [topics, setTopics] = useState<Topic[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await fetch(`/api/frontend/topics?collection=${collection}`)
        if (!response.ok) {
          throw new Error('Failed to fetch topics')
        }
        const { topics } = await response.json()
        setTopics(topics)
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)))
      } finally {
        setLoading(false)
      }
    }
    fetchTopics()
  }, [collection])

  return { topics, loading, error }
}
